import DOMPurify from 'isomorphic-dompurify';

export const purifyText = (source: string | Node) => {
  return DOMPurify.sanitize(source, { ADD_ATTR: ['target'] });
};
